import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Select from "react-select";
import { config, encodeBase64RequestBody, priceFormat, numberFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const UserEdit = () => {
  const { user_keyid } = useParams();
  const [users, setUsers] = useState(null);
  const [fullName, setFullName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [userDepartment, setUserDepartment] = useState('Sales');
  const [userRoleDivision, setUserRoleDivision] = useState('Staff');
  const [userPosition, setUserPosition] = useState('');
  const [userLevel, setUserLevel] = useState('User');
  const [userActive, setUserActive] = useState('Active');
  const [approval_1, setApproval_1] = useState(null);
  const [approval_2, setApproval_2] = useState(null);
  const [joinedDate, setJoinedDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [targetQ1, setTargetQ1] = useState(0);
  const [targetQ2, setTargetQ2] = useState(0);
  const [targetQ3, setTargetQ3] = useState(0);
  const [targetQ4, setTargetQ4] = useState(0);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    if (users) {
      getUser();
      getAttainmentUser();
    }
  }, [users]);

  const getUser = async () => {
    try {
      const requestUser = {
        user_keyid: user_keyid
      };
      const fetchUser = await jwtFetch(config.ENDPOINT + 'get/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestUser)
      });
      const responseUser = await fetchUser.json();
      if (responseUser.status === 200) {
        setFullName(responseUser.data[0].full_name);
        setEmailAddress(responseUser.data[0].email_address);
        setUserDepartment(responseUser.data[0].user_department);
        setUserRoleDivision(responseUser.data[0].user_role_division);
        setUserPosition(responseUser.data[0].user_position);
        setUserLevel(responseUser.data[0].user_level);
        setUserActive(responseUser.data[0].user_active);
        if (responseUser.data[0].approval_1) {
          changeApprovalData('1', responseUser.data[0].approval_1);
        }
        if (responseUser.data[0].approval_2) {
          changeApprovalData('2', responseUser.data[0].approval_2);
        }
        if (responseUser.data[0].joined_date) {
          setJoinedDate(format(responseUser.data[0].joined_date, "yyyy-MM-dd"))
        }
      } else {
        alert(responseUser.message);
      }
    } catch (error) {
      console.error('Error in getUser:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getAttainmentUser = async () => {
    try {
      const requestAttainmentUser = {
        assigned_to: user_keyid,
        target_year: format(new Date(), "yyyy")
      };
      const fetchAttainmentUser = await jwtFetch(config.ENDPOINT + 'get/attainment_user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestAttainmentUser)
      });
      const responseAttainmentUser = await fetchAttainmentUser.json();
      if (responseAttainmentUser.status === 200) {
        responseAttainmentUser.data.forEach(item => {
          if (item.target_quarter === 1) {
            setTargetQ1(item.target_amount || 0);
          } else if (item.target_quarter === 2) {
            setTargetQ2(item.target_amount || 0);
          } else if (item.target_quarter === 3) {
            setTargetQ3(item.target_amount || 0);
          } else if (item.target_quarter === 4) {
            setTargetQ4(item.target_amount || 0);
          }
        });
      } else {
        alert(responseAttainmentUser.message);
      }
    } catch (error) {
      console.error('Error in getAttainmentUser:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getUsers = async () => {
    try {
      const requestUsers = {};
      const fetchUsers = await jwtFetch(config.ENDPOINT + 'get/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestUsers)
      });
      let responseUsers = await fetchUsers.json();
      if (responseUsers.status === 200) {
        for (let i in responseUsers.data) {
          responseUsers.data[i].value = responseUsers.data[i].user_keyid;
          responseUsers.data[i].label = responseUsers.data[i].full_name;
        }
        setUsers([...responseUsers.data].sort((a, b) => (a.full_name || '').localeCompare(b.full_name || '')));
      } else {
        alert(responseUsers.message);
      }
    } catch (error) {
      console.error('Error in getUsers:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const changeApprovalData = (index, value) => {
    const user = users.find(user => user.user_keyid === value);
    if (index === '1') {
      setApproval_1(user);
    } else if (index === '2') {
      setApproval_2(user);
    }
  }

  const submitUserEdit = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);
      const requestUserEdit = {
        "user_keyid": user_keyid,
        "full_name": fullName,
        "email_address": emailAddress,
        "user_position": userPosition,
        "user_department": userDepartment,
        "user_role_division": userRoleDivision,
        "user_level": userLevel,
        "user_active": userActive,
        "approval_1": approval_1 ? approval_1.user_keyid : null,
        "approval_2": approval_2 ? approval_2.user_keyid : null,
        "targets": [
          {
            "target_exchange_rate": 1,
            "target_year": format(new Date(), 'yyyy'),
            "target_quarter": 1,
            "target_amount": targetQ1,
          },
          {
            "target_exchange_rate": 1,
            "target_year": format(new Date(), 'yyyy'),
            "target_quarter": 2,
            "target_amount": targetQ2,
          },
          {
            "target_exchange_rate": 1,
            "target_year": format(new Date(), 'yyyy'),
            "target_quarter": 3,
            "target_amount": targetQ3,
          },
          {
            "target_exchange_rate": 1,
            "target_year": format(new Date(), 'yyyy'),
            "target_quarter": 4,
            "target_amount": targetQ4,
          },
        ],
        "joined_date": joinedDate ? joinedDate : null,
        "action": 'Update',
      }
      const fetchUserEdit = await jwtFetch(config.ENDPOINT + 'update/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestUserEdit)
      });
      const responseUserEdit = await fetchUserEdit.json();
      if (responseUserEdit.status === 200) {
        window.location.href = '/user/detail/' + user_keyid;
      } else {
        alert(responseUserEdit.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitUserEdit:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="user-edit">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="user" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> User Edit</div>
                  <form className="row" onSubmit={(e) => submitUserEdit(e)}>
                    <div className="col-md-6">
                      <div className="sticky-top">
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Name <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <input className="form-control" type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} required />
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Email <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <input className="form-control" type="email" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} required />
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Department <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <select className="form-select" value={userDepartment} onChange={(e) => setUserDepartment(e.target.value)} required>
                              <option value="Sales">Sales</option>
                              <option value="Sales Admin">Sales Admin</option>
                              <option value="Finance">Finance</option>
                              <option value="Marketing">Marketing</option>
                              <option value="Delivery">Delivery</option>
                              <option value="Support">Support</option>
                              <option value="BOD">BOD</option>
                            </select>
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Role <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <select className="form-select" value={userRoleDivision} onChange={(e) => setUserRoleDivision(e.target.value)} required>
                              <option value="Staff">Staff</option>
                              <option value="Senior Staff">Senior Staff</option>
                              <option value="Lead">Lead</option>
                              <option value="Manager">Manager</option>
                              <option value="Head">Head</option>
                            </select>
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Position <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <input className="form-control" type="text" value={userPosition} onChange={(e) => setUserPosition(e.target.value)} required />
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Type <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <select className="form-select" value={userLevel} onChange={(e) => setUserLevel(e.target.value)} required>
                              <option value="User">User</option>
                              <option value="Admin">Admin</option>
                              <option value="View">View</option>
                            </select>
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Join Date</label>
                          </div>
                          <div className="col-md-8">
                            <input className="form-control" type="date" value={joinedDate} onChange={(e) => setJoinedDate(e.target.value)} />
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-4">
                          <div className="col-md-4">
                            <label>Status</label>
                          </div>
                          <div className="col-md-8">
                            <div className="form-check form-switch pt-1">
                              <input id="user-active" className="form-check-input" type="checkbox" value="Active" onChange={() => setUserActive(userActive === 'Active' ? 'Inactive' : 'Active')} checked={userActive === 'Active' ? true : false} />
                              <label htmlFor="user-active" className="form-check-label">{userActive}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card mb-4">
                        <div className="card-body">
                          <div className="fs-18 mb-3">Approval</div>
                          <div className="row form-group align-items-baseline mb-2">
                            <div className="col-md-4">
                              <label>Level 1</label>
                            </div>
                            <div className="col-md-8">
                              <Select value={approval_1} options={users} placeholder="" isClearable onChange={(e) => changeApprovalData('1', e ? e.value : null)} />
                              {approval_1 && (
                                <div className="card my-2">
                                  <div className="card-body">
                                    <p className="mb-0"><i className="bi bi-envelope me-2" /> {approval_1.email_address}</p>
                                    <p className="mb-0"><i className="bi bi-building me-2" /> {approval_1.user_department}</p>
                                    <p className="mb-0"><i className="bi bi-suitcase-lg me-2" /> {approval_1.user_role_division}</p>
                                    <p className="mb-0"><i className="bi bi-person-badge me-2" /> {approval_1.user_position}</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="row form-group align-items-baseline mb-2">
                            <div className="col-md-4">
                              <label>Level 2</label>
                            </div>
                            <div className="col-md-8">
                              <Select value={approval_2} options={users} placeholder="" isClearable onChange={(e) => changeApprovalData('2', e ? e.value : null)} />
                              {approval_2 && (
                                <div className="card my-2">
                                  <div className="card-body">
                                    <p className="mb-0"><i className="bi bi-envelope me-2" /> {approval_2.email_address}</p>
                                    <p className="mb-0"><i className="bi bi-building me-2" /> {approval_2.user_department}</p>
                                    <p className="mb-0"><i className="bi bi-suitcase-lg me-2" /> {approval_2.user_role_division}</p>
                                    <p className="mb-0"><i className="bi bi-person-badge me-2" /> {approval_2.user_position}</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {userDepartment === 'Sales' && userLevel === 'User' && (
                        <div className="card mb-4">
                          <div className="card-body">
                            <div className="fs-18 mb-3">Target</div>
                            <div className="row form-group align-items-baseline mb-2">
                              <div className="col-md-4">
                                <label>Q1 {format(new Date(), 'yyyy')}</label>
                              </div>
                              <div className="col-md-8">
                                <div className="input-group mb-1">
                                  <input className="form-control text-end" type="text" value={priceFormat(targetQ1)} onChange={(e) => setTargetQ1(numberFormat(e.target.value))} />
                                  <span className="input-group-text">IDR</span>
                                </div>
                              </div>
                            </div>
                            <div className="row form-group align-items-baseline mb-2">
                              <div className="col-md-4">
                                <label>Q2 {format(new Date(), 'yyyy')}</label>
                              </div>
                              <div className="col-md-8">
                                <div className="input-group mb-1">
                                  <input className="form-control text-end" type="text" value={priceFormat(targetQ2)} onChange={(e) => setTargetQ2(numberFormat(e.target.value))} />
                                  <span className="input-group-text">IDR</span>
                                </div>
                              </div>
                            </div>
                            <div className="row form-group align-items-baseline mb-2">
                              <div className="col-md-4">
                                <label>Q3 {format(new Date(), 'yyyy')}</label>
                              </div>
                              <div className="col-md-8">
                                <div className="input-group mb-1">
                                  <input className="form-control text-end" type="text" value={priceFormat(targetQ3)} onChange={(e) => setTargetQ3(numberFormat(e.target.value))} />
                                  <span className="input-group-text">IDR</span>
                                </div>
                              </div>
                            </div>
                            <div className="row form-group align-items-baseline mb-4">
                              <div className="col-md-4">
                                <label>Q4 {format(new Date(), 'yyyy')}</label>
                              </div>
                              <div className="col-md-8">
                                <div className="input-group mb-1">
                                  <input className="form-control text-end" type="text" value={priceFormat(targetQ4)} onChange={(e) => setTargetQ4(numberFormat(e.target.value))} />
                                  <span className="input-group-text">IDR</span>
                                </div>
                              </div>
                            </div>
                            <div className="row form-group align-items-baseline mb-2">
                              <div className="col-md-4">
                                <label><strong>Total</strong></label>
                              </div>
                              <div className="col-md-8">
                                <div className="input-group mb-1">
                                  <input className="form-control text-end" type="text" value={priceFormat(numberFormat(targetQ1) + numberFormat(targetQ2) + numberFormat(targetQ3) + numberFormat(targetQ4))} disabled />
                                  <span className="input-group-text">IDR</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/user/detail/' + user_keyid}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Update'}</button>
                      </div>
                    </div>
                  </form>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEdit;


